import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VBtn,
    {
      staticClass: "px-2",
      attrs: {
        height: _vm.dataHeight,
        width: _vm.dataWidth,
        dark: "",
        color: "#0D1117",
      },
      on: { click: _vm.loginWithGithub },
    },
    [
      _c("div", { staticClass: "full-width d-flex justify-md-space-between" }, [
        _c("img", {
          staticClass: "v-icon",
          style: _vm.iconStyle,
          attrs: {
            src: require("@/assets/images/icons/socialmedia/github/github-tile.svg"),
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-grow-1 d-flex justify-center align-center" },
          [
            _c("span", { staticClass: "font-weight-bold text-subtitle-1" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("components.AtGithubLoginAtom.text")) +
                  "\n      "
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }